import { trimEndSlash, makeTokenRequest, getTokenRequestParameters } from "../../helpers";
import { WALLET_ENDPOINTS, RequestMethods } from "../../constants";
export class WalletRequestService {
    constructor(baseAnonymousApiUrl, ajaxService, storage, domainID) {
        this.baseAnonymousApiUrl = baseAnonymousApiUrl;
        this.ajaxService = ajaxService;
        this.storage = storage;
        this.domainID = domainID;
    }
    getAnonymousToken() {
        return makeTokenRequest(this.ajaxService, getTokenRequestParameters(`${trimEndSlash(this.baseAnonymousApiUrl)}/${WALLET_ENDPOINTS.ANONYMOUS}`, this.getParsedToken.bind(this), JSON.stringify({
            DomainId: this.domainID
        }), this.getRequestProperties()));
    }
    getRenewedToken(token) {
        return makeTokenRequest(this.ajaxService, getTokenRequestParameters(`${trimEndSlash(this.baseAnonymousApiUrl)}/${WALLET_ENDPOINTS.RENEW}`, this.getParsedToken.bind(this), JSON.stringify({
            token
        }), this.getRequestProperties({ token })));
    }
    getLoginRequestBody(params) {
        let body = {
            token: params.token,
            DomainId: this.domainID.toString()
        };
        return JSON.stringify(body);
    }
    onLoginTokenSuccess(response) {
        const token = this.getParsedToken(response);
        this.storage.setToken(token);
        return token;
    }
    getParsedToken(response) {
        let parsedResponse = JSON.parse(response);
        if (!parsedResponse.success) {
            throw new Error(parsedResponse.message);
        }
        return parsedResponse.jwt;
    }
    getLoginToken(params) {
        return makeTokenRequest(this.ajaxService, getTokenRequestParameters(`${trimEndSlash(this.baseAnonymousApiUrl)}/${WALLET_ENDPOINTS.LOGIN}`, this.onLoginTokenSuccess.bind(this), this.getLoginRequestBody(params), this.getRequestProperties(params)));
    }
    getRequestProperties(params) {
        let requestProperties = {
            method: RequestMethods.POST
        };
        if (params === null || params === void 0 ? void 0 : params.token) {
            requestProperties.headers = {
                Authorization: `Bearer ${params.token}`
            };
        }
        return requestProperties;
    }
}
//# sourceMappingURL=WalletRequestService.js.map